import { render, staticRenderFns } from "./SurveysFeatureModal.vue?vue&type=template&id=6b94260b&scoped=true&"
import script from "./SurveysFeatureModal.vue?vue&type=script&lang=ts&"
export * from "./SurveysFeatureModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94260b",
  null
  
)

export default component.exports